/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
  SET_ACTIVE_SPACE_URL(state, url) {
    state.ActiveSpaceInfo['url'] = url
  },
  SET_ACTIVE_SPACE_TITLE(state, name) {
    state.ActiveSpaceInfo['title'] = name
  },
  SET_ACTIVE_SPACE_ID(state, id) {
    state.ActiveSpaceInfo['id'] = id
  },
  SET_ACTIVE_SPACE(state, payload) {
    state.ActiveSpaceInfo = payload
  },
  SET_WORKSPACE_LIST(state, payload){
    state.workspaces = payload.sort(function(a,b) {return a.update_time > b.update_time ? -1 : a.update_time > b.update_time ? 1 : 0 })
    state.serviceWorkspaces = payload.filter((workspace) => workspace.service == true)
  },
  SET_SHARE_CLASS(state, id){
    state.shareClass = []
    for (var index in state.serviceWorkspaces){
      if(id != state.serviceWorkspaces[index].id && state.serviceWorkspaces[index].level > 2){
        state.shareClass.push({label: state.serviceWorkspaces[index].title,  value: state.serviceWorkspaces[index].id})
      }
    }
  },
  ADD_WORKSPACE(state, payload){
    state.workspaces.unshift(payload)
  },
  UPDATE_WORKSPACE_TITLE(state, payload){
      const index = state.workspaces.findIndex((space) => space.id == payload.id)
      state.workspaces[index].title = payload.title
  },
  DELETE_WORKSPACE(state, payload){
      const index = state.workspaces.findIndex((space) => space.id ==payload)
      state.workspaces.splice(index,1)
  },
  SET_INVITE_LIST(state, payload){
    state.inviteList = payload
  },
  SET_WORKSPACE_MEMBERS_LIST(state, payload){
    state.workspaceMembers = payload
    for(var i = 0; i < state.workspaceMembers.length; i++){
      Vue.set(state.workspaceMembers[i], 'checkValue', false)
    }
  },
  SET_ACTIVE_USER_LEVEL(state, payload){
    for(var i = 0; i < state.workspaceMembers.length; i++){
      if(payload == state.workspaceMembers[i].user_id){
        state.ActiveDashBoardLevel = state.workspaceMembers[i].level
        return
      }
    }
    state.ActiveDashBoardLevel = 0
  },
  DELETE_MEMBER_LIST(state, payload){
    for(var i = 0; i < payload.members.length; i++){
      const memberIndex = state.workspaceMembers.findIndex((member) => member.user_id == payload.members[i].user_id)
      state.workspaceMembers.splice(memberIndex,1)
    }
  },
  UPDATE_MEMBERS_LEVEL(state, payload){
    for(var i = 0; i < payload.length; i++){
      const memberIndex = state.workspaceMembers.findIndex((member) => member.id == payload[i].id)
      state.workspaceMembers[memberIndex].level = payload[i].level
    }
  },
  UPDATE_WORKSPACE_MEMBERS_CHECKBOX(state, payload){
    var index = state.workspaceMembers.findIndex(function(item){return item.id == payload.id})
    state.workspaceMembers[index].checkValue = payload.checkValue
  },
  UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE(state, payload){
    state.checkboxClassState = payload
  },
  UPDATE_WORKSPACE_CHECKBOX_ALONE_STATE(state, payload){
    state.checkboxAloneState = payload
  },
}
